// extracted by mini-css-extract-plugin
export default {"wrapper":"Top100_wrapper__JFaGy","title":"Top100_title__GABvG","list":"Top100_list__zJdUA"};